import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import "@fontsource/vazirmatn/400.css";
import "@fontsource/vazirmatn/500.css";
import "@fontsource/vazirmatn/600.css";
import "@fontsource/vazirmatn/700.css";
import "./styles/globals.css";
import { App } from "./App";
import { AuthGate } from "./components/AuthGate";
import { SmsNotice } from "./components/SmsNotice";
import { installLogHooks, appendLog } from "./lib/logger";
import { preloadPdfRuntime } from "./lib/pdfAssets";
import {
  clearStaleServiceWorkers,
  configureNativeChrome,
} from "./lib/nativeChrome";

installLogHooks();

void (async () => {
  await clearStaleServiceWorkers();
  await configureNativeChrome();
  if (Capacitor.isNativePlatform()) {
    appendLog("info", "boot", "native chrome ready", {
      platform: Capacitor.getPlatform(),
    });
  }
  // Warm pdf.js assets ASAP — first open after OTA must not race the worker.
  void preloadPdfRuntime();
})();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthGate>
      <App />
    </AuthGate>
    <SmsNotice />
  </StrictMode>
);
